import React, { useEffect, useState } from "react";
import { TaggingFilter, TaggingFilterWrapper } from "./styled";
import { Checkbox, FormControlLabel, Stack, Typography } from "@mui/material";
import { TagTypeEnum } from "../../enums/TagTypeEnum";
import { useContentStore } from "../../stores/contentStore";
import {
  black,
  limeGreen,
  paleRed,
  paleViolet,
  paleYellow,
} from "../../utils/StyleHelpers";

const SearchFilter = (props: any) => {
  const [isShowOCR, setIsShowOCR] = useState(true);
  const [isShowLabel, setIsShowLabel] = useState(true);
  const [isShowObject, setIsShowObject] = useState(true);
  const [isShowTranscript, setIsShowTranscript] = useState(true);
  const setFilterTypes = useContentStore((state: any) => state.setFilterTypes);

  const checkboxStyle = {
    color: black,
    paddingLeft: 0,
    paddingTop: 0,
    paddingBottom: 0,
  };

  const getCheckBoxStyle = (isChecked: boolean, isDisabled: boolean) => ({
    padding: "0.625rem 0.75rem",
    borderRadius: "0.5rem",
    color: isDisabled ? black : "",
    ...(isChecked
      ? {}
      : {
          border: "1px solid #000",
        }),
  });

  useEffect(() => {
    const enabledFilter = [];

    if (isShowOCR && isShowLabel && isShowObject && isShowTranscript) {
      setFilterTypes("");
      return;
    }

    if (isShowOCR) enabledFilter.push(TagTypeEnum.OCR);
    if (isShowLabel) enabledFilter.push(TagTypeEnum.label);
    if (isShowObject) enabledFilter.push(TagTypeEnum.object);
    if (isShowTranscript) enabledFilter.push(TagTypeEnum.transcript);

    setFilterTypes(enabledFilter.join(","));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShowOCR, isShowLabel, isShowObject, isShowTranscript]);
  return (
    <Stack
      direction="row"
      style={{
        borderRadius: "0.5rem",
        padding: "0.25rem",
        gap: "2.5rem",
        alignItems: "center",
        justifyContent: "center",
        width: "40.19rem",
      }}
    >
      <Stack
        direction="row"
        style={{
          padding: "0.25rem",
          gap: "2.5rem",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <TaggingFilter>{props.label}</TaggingFilter>
        <TaggingFilterWrapper>
          {[
            {
              checked: isShowOCR,
              setChecked: setIsShowOCR,
              label: TagTypeEnum.OCR,
              color: limeGreen,
            },
            {
              checked: isShowLabel,
              setChecked: setIsShowLabel,
              label: TagTypeEnum.label,
              color: paleYellow,
            },
            {
              checked: isShowObject,
              setChecked: setIsShowObject,
              label: TagTypeEnum.object,
              color: paleRed,
            },
            {
              checked: isShowTranscript,
              setChecked: setIsShowTranscript,
              label: TagTypeEnum.transcript,
              color: paleViolet,
            },
          ].map(({ checked, setChecked, label, color }) => (
            <FormControlLabel
              key={label}
              control={
                <Checkbox
                  checked={checked}
                  onChange={(_event: any, checked: boolean) =>
                    setChecked(checked)
                  }
                  style={checkboxStyle}
                  disabled={props.isCheckboxDisabled}
                />
              }
              label={
                <Typography
                  style={{ color: props.isCheckboxDisabled ? black : "" }}
                >
                  {label}
                </Typography>
              }
              style={{
                ...getCheckBoxStyle(checked, props.isCheckboxDisabled),
                background: checked ? color : "",
              }}
            />
          ))}
        </TaggingFilterWrapper>
      </Stack>
    </Stack>
  );
};
export default SearchFilter;
